/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";
import { ButtonToolbar } from "react-bootstrap";

import GridList from "../collection/GridList";
import { templateStrings } from "../../../Constant";
import { PageWrapper } from "../../../shared/layout";
import BusDetailDayWiseList from "./BusDetailDayWiseList";
import { CityWiseId, roles } from "../../../lib/constants";
import { style2 as useStyles } from "../../../styles/makeStyles";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import { BarLoader, ExportButton, RangePicker } from "../../../shared/widgets";
import { breakDownCollectionSummaryAction, navigationDataAction, dayWiseBreakDownViewAction } from "../../../redux/action-creators/dayWiseBreakDownActionCreator";
import { fetchCityAndOperator } from "../../../shared/utils";

const updateDateFilterProps = (dates, selectDateFilterProps) => {
  if (dates.startDate && dates.endDate) {
    const fromDate = parseFloat(new Date(dates.startDate).getTime());
    const toDate = parseFloat(new Date(dates.endDate).getTime());
    selectDateFilterProps({ fromDate, toDate });
  }
};

function BusDetail(props) {
  const {
    location, operatorFilter, fetchNavigationData, fetchBusDetailSummary,
    cityFilter, selectedDateFilter, navLoader, breakDownView,
    selectDateFilter: selectDateFilterProps, dayWiseBreakDownView, content, collectionLoader,
    user,
  } = props;
  const classes = useStyles();
  const busNumber = (props && location?.state?.busNumber) || "";
  const operatorId = props && operatorFilter;

  React.useEffect(() => {
    if (props) {
      fetchNavigationData({ busNumber }, "navLoader");
      fetchBusDetailSummary({
        cityFilter, busNumber, operatorId, dateFilter: selectedDateFilter,
      }, "collectionLoader");
    }
  }, []);

  React.useEffect(() => fetchCityAndOperator(props), [navLoader]);

  React.useEffect(() => {
    if (breakDownView) {
      fetchBusDetailSummary({
        cityFilter, busNumber, operatorId, dateFilter: selectedDateFilter,
      }, "collectionLoader");
    }
  }, [selectedDateFilter, cityFilter, operatorFilter]);

  const handleDatesChange = (dates) => {
    updateDateFilterProps(dates, selectDateFilterProps);
  };

  const exportBusDetailCollectionDataEndpoint = "collectionPage/exportBusDetailCollectionData";
  const exportBusDetailCollectionDataQuery = {
    platform: "web",
    timezoneOffset: -330,
    addOnFilter: {
      busNumber: busNumber || "",
      cityIdArr: cityFilter || [],
      operatorIdArr: operatorFilter || [],
      date: selectedDateFilter || "",
    },
  };

  const handleBack = () => {
    dayWiseBreakDownView(false);
    const { history } = props;
    history.replace("/collection", location.state);
  };

  const gridItems = content;
  const isLoading = collectionLoader;
  let gridStrings = templateStrings.collectionDetailGridItems;

  if (
    (user?.cityIds?.includes(CityWiseId.Mumbai)) && (user.role === roles.agencyManager)
  ) {
    gridStrings = JSON.parse(JSON.stringify(gridStrings));
    delete gridStrings.averageBuses;
  }

  return (
    <div className={classes.root}>
      <PageWrapper>
        <Hidden only={["lg", "xl", "md"]}>
          <div className={classes.picker}>
            <RangePicker
              startDate={moment(new Date(selectedDateFilter.fromDate))}
              endDate={moment(new Date(selectedDateFilter.toDate))}
              onDatesChange={handleDatesChange}
              monthsToDisplay={1}
            />
          </div>
        </Hidden>
        <div className="page-header">
          <div
            role="button"
            className="back-arrow"
            onClick={handleBack}
            onKeyDown={() => {
              // onKeyDown
            }}
            tabIndex="0"
            aria-label="back"
          >
            <div className="back-action" />
          </div>
          <div className="page-header-title">{busNumber}</div>
          <Hidden only={["sm", "xs"]}>
            <div className="pull-right">
              <ExportButton
                query={exportBusDetailCollectionDataQuery}
                endpoint={exportBusDetailCollectionDataEndpoint}
                pageName="Collection"
              />
            </div>
            <div className="pull-right">
              <ButtonToolbar>
                <RangePicker
                  startDate={moment(new Date(selectedDateFilter.fromDate))}
                  endDate={moment(new Date(selectedDateFilter.toDate))}
                  onDatesChange={handleDatesChange}
                  monthsToDisplay={1}
                />
              </ButtonToolbar>
            </div>
          </Hidden>
        </div>

        <div className="custom-grid-layout">
          {Object.keys(gridStrings).map((column, index) => (
            <div key={index} className="custom-grid">
              <GridList
                isLoading={isLoading}
                value={gridItems[column]}
                gridItemsData={gridItems}
                template={column}
                type="collectionDetailGridItems"
              />
            </div>
          ))}
        </div>
        <div>
          <PageWrapper.Header heading="Day wise breakdown" isHeaderFixed={false} hideS removeFilterOnly hideDivider hideLower>
            <div className="dataTables_length tabWrapper" />
            <div className="pull-right search-container">
              {/* <SearchBar
              // placeHolder={this.state.placeHolder} onSearchChange={this.handleSearchChange}
              /> */}
            </div>
          </PageWrapper.Header>
        </div>
        <BarLoader scope="header" />
        <BusDetailDayWiseList busNumber={busNumber} />
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content: state.BreakDown.breakDownCollectionSummary,
    navData:
      (state
        && state.BreakDown
        && state.BreakDown.navData)
      || {},
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    collectionLoader: state && state.loadingBar && state.loadingBar.collectionLoader,
    breakDownView: state.BreakDown.breakDownView,
    navLoader: state && state.loadingBar && state.loadingBar.navLoader,
    detailLoader: state && state.loadingBar && state.loadingBar.detailLoader,
    user: state.Auth.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchBusDetailSummary: (params, loaderScope) => {
    dispatch(breakDownCollectionSummaryAction(params, loaderScope));
  },
  dayWiseBreakDownView: (params, loaderScope) => {
    dispatch(dayWiseBreakDownViewAction(params, loaderScope));
  },
  fetchNavigationData: (params, loaderScope) => {
    dispatch(navigationDataAction(params, loaderScope));
  },
  // fetchCities: (user,loaderScope) => {
  //   dispatch(createCitiesListAction(user,loaderScope));
  // },
  // fetchCityOperators: (params, loaderScope) => {
  //   dispatch(cityOperatorsListAction(params, loaderScope));
  // },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BusDetail);
